import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/src/app/about/components/CompanyTimeline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/src/app/about/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/697512271beda800144fd2bf/pink_diamond_corporate/src/components/ui/AppImage.tsx");
